@if (!isIconButton) {
  <button
    [type]="type"
    id={{inId}}
    class="uw-default-button mx-2"
    class="{{customClass}}"
    [disabled]="disabled"
    (click)="onClick()"
    [ngStyle]="customStyle"
    [attr.aria-label]="btnLabel"
    [ngClass]="{'loading' : loading, 'disabled': disabled, 'medium-button': isMediumSize}"
    routerLink="login">
    @if (!loading) {
      @if (buttonIcon) {
        <i class="{{buttonIcon}}"></i>
      }
      {{btnLabel}}
    } @else {
      <div class="loading-btn-container">
        <mat-spinner diameter="25"></mat-spinner>
        <span>{{ "common.please_wait" | translate }}</span>
      </div>
    }
  </button>
}

@if (isIconButton) {
  <button mat-icon-button [title]="btnLabel" class="mx-2 primary-icon-button" [attr.aria-label]="btnLabel"
    (click)="onClick()">
    <i [ngClass]="buttonIcon"></i>
  </button>
}
